import { Instance } from 'mobx-state-tree';
import { ProjectStopsScheduledDtoModelBase } from './ProjectStopsScheduledDtoModel.base';

/* The TypeScript type of an instance of ProjectStopsScheduledDtoModel */
export interface ProjectStopsScheduledDtoModelType extends Instance<typeof ProjectStopsScheduledDtoModel.Type> {}

/* A graphql query fragment builders for ProjectStopsScheduledDtoModel */
export { selectFromProjectStopsScheduledDto, projectStopsScheduledDtoModelPrimitives, ProjectStopsScheduledDtoModelSelector } from './ProjectStopsScheduledDtoModel.base';

/**
 * ProjectStopsScheduledDtoModel
 *
 * Scheduled stops
 */
export const ProjectStopsScheduledDtoModel = ProjectStopsScheduledDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
